





























































































































import Vue from "vue";
import FilteringMain from "@/components/FilteringMainv2.vue";
import TravelFeatures from "./school/TravelFeatures.vue";
import SingleOrganization from "@/modals/SingleOrganization.vue";
import ApiService from "@/services/ApiService";
export default Vue.extend({
  components: {
    FilteringMain,
    TravelFeatures,
  },
  data() {
    return {
      organizations: [],
      search: "",
      council_id: null,
      school_id: null,
      loading: true,
      showMainModal: false,
      queryParamsForTD: "",
      title: "",
      organizationType: "all",
    };
  },
  methods: {
    updateMainFilter(data) {
      if (data.school_ids.length > 0) {
        if (
          typeof data.school_ids[0] == "string" &&
          data.school_ids[0][0] == "c"
        ) {
          //it's a council like council_5
          const exploded = data.school_ids[0].split("council_");
          this.council_id = exploded[1];
          this.school_id = null;
        } else if (typeof data.school_ids[0] == "number") {
          this.council_id = null;
          this.school_id = data.school_ids[0];
        }
      } else {
        this.search = "";
        this.council_id = null;
      }
      this.filterOptions = data;
      this.showSchoolIds = data.school_ids ? data.school_ids : [];
    },
    newSchool() {
      this.$router.push({
        name: "Edit Organization",
        params: { org_id: "new" },
      });
    },
    openSchool(id) {
      this.$modal.show(
        SingleOrganization,
        {
          options: {
            profilePicture: true,
          },
          id,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          height: "auto",
          adaptive: true,
          // pivotY: 0
        },
        {
          "before-close": this.beforeClose,
          // newAvatar: payload => {
          //   this.selectedImage =
          //     payload.url + payload.gender + payload.id + ".png";
          //   console.log(payload);
          // }
        }
      );
    },
    openTravelDirectory(id, title) {
      this.queryParamsForTD = "type=school&type_id=" + id;
      this.showMainModal = true;
      this.title = title;
    },
    getOrganizations() {
      ApiService.generalApi
        .getOrganizations(this.$route.params.type)
        .then((response: any) => {
          this.organizations = response.data;
          this.loading = false;
        });
    },
    closeMainModal() {
      this.showMainModal = false;
    },
    beforeClose(event) {
      // alert("ff");
    },
  },
  computed: {
    accType: function () {
      return this.$store.state.accType;
    },
  },
  watch: {
    "$route.params.type": {
      handler: function () {
        this.getOrganizations();
        this.organizationType = this.$route.params.type;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.organizationType = this.$route.params.type;
    // const accType = this.$store.state.accType;
  },
});
